<template>
  <div>
    <div class="left_tree">
      <a-spin :spinning="treeSpin" style="height: 100%">
        <div>
          <vxe-button @click="add" style="margin:0 3px 10px 0">新增</vxe-button>
          <vxe-button @click="edit" style="margin:0 3px 10px 0">编辑</vxe-button>
          <vxe-button @click="del" style="margin:0 3px 10px 0">删除</vxe-button>
        </div>
        <a-tree
                :show-icon="true"
                :checkStrictly="true"
                :defaultExpandAll="false"
                :defaultExpandParent="true"
                :expandedKeys.sync="defaultExpandedKeys"
                :tree-data="deptList"
                :selectedKeys="selectedKeys"
                :replaceFields="{children:'children', title:'speechTypeName', key:'speechTypeId', value: 'speechTypeId' }"
                @select="onSelect"
                @check="onCheck"
        >
          <!--          :checkable="true"-->
          <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
          <a-icon type="cluster" slot="region" style="color:#52c41a"/>
        </a-tree>
      </a-spin>
    </div>
    <div class="right_table">
      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :pager-config="pagerConfig"
          :form-config="formConfig"
          :url="url"
          :columns="columns"
          :other-params="{
            speechTypeId :speechTypeId
          }"
          :checkbox-config="checkboxConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :export-config="exportConfig"
          ref="grid"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
          @toolbar-addData="addRow"
          @toolbar-delData="delRow"
      >
        <template v-slot:[toolbarConfig.templatelSlots]>

        </template>
      </x-grid>
    </div>

    <!--明细页表单简化通用写法-->
    <formModal title="常用话术" :visible="editModalVisible">
      <detailForm :rowId="editRowId"

                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
<!--      :speechTypeId="speechTypeId"-->
    </formModal>

    <a-modal
        title="客户分组"
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editQuestion"
        @cancel="closeQuestion()"
        :width="600"
    >
      <speech :rowId="editQuestionId"
              :parentId="parentId"
              v-if="editQuestion"
              ref="editQuestion"
              @cancelled="closeQuestion()"
              @saved="closeQuestion(true)">
      </speech>
    </a-modal>

  </div>
</template>

<script>
import {
  GridMixin,
  api,
  fac,
  mapState
} from "@/utils/common/XGridBase"

import {dataApi} from "@/services/question/speech";
import {XEUtils} from "@/utils/common/FormBase";
import detailForm from "./speechDetail";
import speech from "./detail/speechTreeDetail";

//列表接口
const url = api.answer.SPEECH;

//主键
const rowId = "speechId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("speechName", "常用语", 340),
  fac.makeColumn("createUserName", "创建者", 140),
  fac.makeColumn("keyWordsNames", "关键词", 140),
  fac.makeColumn("createDate", "创建时间", 140),
  fac.makeColumn("lastModifyDate", "最后修改时间", 140),
  fac.makeColumn("usedCount", "使用次数", 140),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "speechName"},
  {field: "keyWordsNames"}
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: true,
  addData: true,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  authorize: {},
  components: {
    detailForm,
    speech
    // setPassword,
  },
  computed: {
    ...mapState("account", {currUser: "user"}),
  },
  mounted() {
    this.getQuestionTree();
  },
  data() {
    return {
      // popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      checkedKeys: [],
      allList: [],
      deptList: [],
      defaultExpandedKeys: [],
      selectedKeys: [],
      treeSpin: false,
      token: localStorage.getItem('token'),
      editQuestion: false,
      editQuestionId: 0,
      parentId: 0,
      speechTypeId: ''
    };
  },
  methods: {
    async getQuestionTree() {
      let deptList = await dataApi.getQuestionTree();
      this.allList = deptList.data;
      this.deptList = XEUtils.toArrayTree(deptList.data, {
        key: 'speechTypeId',
        parentKey: 'parentId',
        children: 'children'
      })
      // this.defaultExpandedKeys = deptList.data.map(val => {
      //   //默认只展开一级
      // })
    },
    /**
     * 选中树
     * @param selectedKeys
     */
    onSelect(selectedKeys) {
      this.selectedKeys = selectedKeys;
      this.speechTypeId = selectedKeys[0];

      this.$nextTick(() => {
        this.refresh()
      })
    },
    /**
     * 选择复选框
     * @param checkedKeys
     */
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys.checked;
    },
    add() {
      if (this.selectedKeys.length) {
        this.parentId = this.selectedKeys[0]
      } else {
        this.parentId = null
      }
      this.editQuestionId = 0
      this.editQuestion = true
    },
    edit() {
      if (this.selectedKeys.length) {
        this.editQuestionId = this.selectedKeys[0]
        this.editQuestion = true
      } else {
        this.$message.error('请选择问题分组')
      }
    },
    del() {
      const vm = this
      if (this.selectedKeys.length) {
        this.$confirm({
          title: '确定要删除分组吗',
          content: '',
          onOk() {
            vm.doDel()
          },
          onCancel() {
            console.log('Cancel');
          }
        });
      } else {
        this.$message.error('请选择问题分组')
      }
    },
    doDel() {
      dataApi.delQuestionTree(this.selectedKeys[0]).then(res => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getQuestionTree()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    closeQuestion(flag) {
      this.editQuestion = false
      if (flag) {
        this.getQuestionTree()
      }
    }
  },
};
</script>

<style scoped lang="less">
.left_tree {
  width: 20%;
  padding: 20px;
  float: left;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: auto;
}

.right_table {
  width: 80%;
  float: right;
  height: 100%;
}

///deep/ .ant-spin-container {
//  height: 100%;
//  display: flex;
//  flex-direction: column;
//}
///deep/ .ant-tree {
//  flex: 1;
//  overflow-y: scroll;
//}
</style>
